// src/api/index.js
import axios from 'axios'

// 创建axios实例，配置后端基础地址
const api = axios.create({
    baseURL: 'https://www.scgydl.com.cn/api', // 后端服务地址（生产环境）
    timeout: 5000
})


// 公司信息API
export const companyApi = {
    getCompanyInfo() {
        return api.get('/company/info')
    }
}

// 联系表单API
export const contactApi = {
    submitContact(data) {
        return api.post('/contacts', data)
    }
}

// 其他API（如果需要）
export const partnerApi = {
    getAllPartners() {
        return api.get('/partners')
    },
    getMainPartners() {
        return api.get('/partners/mainPartners')
    }
}

export const caseApi = {
    // 正确：pageNum从0开始（第1页pageNum=0，第2页pageNum=1...）
    getCasesByPage(pageNum = 0, pageSize = 6) {
        return api.get(`/cases?pageNum=${pageNum}&pageSize=${pageSize}`);
    },
    getCaseById(id) {
        return api.get(`/cases/${id}`)
    },
    getCaseCount() {
        return api.get('/cases/count')
    },
    getAllCases() {
        return api.get('/cases')
    }
}

// 新闻API
export const newsApi = {
    getCarouselSlides() {
        return api.get('/news/carousel')
    },
    getNewsList() {
        return api.get('/news/list')
    },
    getNewsById(id) {
        return api.get(`/news/detail/${id}`)
    },
    getLatestNews(limit) {
        return api.get(`/news/latest/${limit}`)
    }
}